import { Bits } from './bits';

export enum PixelPermissions {
	CanAccessPixels = Bits.Bit1
}
